import { DetailedComplexEnumItem } from '../../utils/complexEnum/DetailedComplexEnumItem'

export class StatusEnumItem<
  Name extends string,
  Priority extends number,
  ID extends string
> extends DetailedComplexEnumItem<ID, Name> {
  /**
   * the sort priority of the status
   *
   * this should be zero-indexed
   */
  priority: Priority
  constructor({
    priority,
    ...detailed
  }: Pick<
    StatusEnumItem<Name, Priority, ID>,
    'id' | 'description' | 'name' | 'priority'
  >) {
    super(detailed)
    this.priority = priority
  }
}
